import { useState } from 'react'
import { orario, syncAndWait, syncPortaliApi } from '../api/syncPortali'
import { Button } from './ui'

/**
 * Pulsante "Sync": legge subito stati e dati dal portale dell'operatore della pratica, senza aspettare il giro
 * periodico. Ermes e Teamwork passano dal server (richiesta eseguita entro un minuto); Coraly si legge dal CRM.
 */
export function PortalSyncButton({ gestore, contractId, onDone }: {
  gestore: 'ermes' | 'teamwork' | 'coraly'
  contractId: number
  onDone: () => void
}) {
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState<string | null>(null)

  async function run() {
    setBusy(true)
    setMsg(gestore === 'coraly' ? 'Lettura da Coraly…' : 'Sync richiesto: il server legge il portale (di solito 1-3 minuti)…')
    try {
      if (gestore === 'coraly') {
        await syncPortaliApi.coraly(contractId)
        setMsg(`Aggiornato da Coraly alle ${orario(new Date().toISOString())}.`)
      } else {
        const s = await syncAndWait(gestore, undefined, t => { if (t.avviataIl && t.inCorso) setMsg('Sync in corso: lettura del portale…') })
        setMsg(s.inCorso
          ? 'Il sync è ancora in corso: riapri la pratica tra qualche minuto.'
          : s.esito === 'in pausa' ? 'Sincronizzazione in pausa (Integrazioni → Sincronizzazione portali).'
          : `Aggiornato alle ${orario(s.eseguitaIl)}${s.esito && s.esito !== 'ok' ? ` (${s.esito})` : ''}.`)
      }
      onDone()
    } catch (err) {
      setMsg(err instanceof Error ? err.message : 'Sync non riuscito.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <Button variant="text" onClick={() => { void run() }} disabled={busy}>{busy ? 'Sync…' : 'Sync portale'}</Button>
      {msg && <span className="md-typescale-body-small">{msg}</span>}
    </span>
  )
}
